import { BuildModuleParamsType } from 'types/api-internal';
import { SugarMoneyApiGetRanksResponseType } from 'types/ranks';

export const ranksModule = ({ makeApiRequest }: BuildModuleParamsType) => ({
  getRanks: async () =>
    makeApiRequest<SugarMoneyApiGetRanksResponseType>({
      endpoint: 'ranks',
      options: { method: 'get' },
    }),
});
